<template>
  <div class="camp-page">
    <!-- 在 van-search 外层增加 form 标签，且 action 不为空，即可在 iOS 输入法中显示搜索按钮。 -->
    <form action="xx">
      <van-search
        v-model="searchText"
        show-action
        placeholder="输入班级/营养师名称"
        @search="onSearch"
        clearable
      >
        <template #action>
          <div @click="bindClickSearch" class="search-btn">搜索</div>
        </template>
      </van-search>
    </form>
    <div class="camp-content">
      <div class="camp-scroll">
        <van-pull-refresh v-model="refreshing" @refresh="getCampList(1)">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="camp-container">
              <div class="camp-list">
                <div
                  class="camp-item"
                  :class="{ 'end-item': item.is_end !== 0 }"
                  v-for="(item, index) in selectCampList"
                  :key="index"
                  @click.stop="jumpDynamicPage(item)"
                >
                  <div class="item-top">
                    <div class="left">
                      <div class="top">
                        <div class="name">{{ item.title }}</div>
                      </div>
                      <div class="bottom">
                        <span class="time"
                          >{{ item.s_date }} - {{ item.e_date }}</span
                        >
                        <span class="coach-name">{{
                          item.camp_coach || ''
                        }}</span>
                      </div>
                    </div>
                    <div class="not-read" v-if="item.total_u_p">
                      {{ item.total_u_p | filterNotRead }}
                    </div>
                    <div
                      class="status"
                      :style="{ background: item.statusBg }"
                      >{{ item.statusText }}</div
                    >
                    <div class="iconfont icon-you"></div>
                  </div>
                  <!-- <div class="observe-btn" v-if="item.open_7">
                    <span>观察期饮食</span>
                    <span class="iconfont icon-you"></span>
                  </div> -->
                </div>
                <div class="not-more" v-if="loaded && !campList.length">
                  暂无营期
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'nutritionist-tool-camp-list',
  data() {
    return {
      searchText: '',
      refreshing: false,
      loading: false,
      finished: false,
      campList: [],
      selectCampList: [],
      loaded: false,
      cid: 0,
      statusArr: [
        {
          text: '未开始',
          status: -1,
          statusBg: '#f39830'
        },
        {
          text: '进行中',
          status: 0,
          statusBg: '#2882e9'
        },
        {
          text: '已结束',
          status: 1,
          statusBg: '#888888'
        }
      ],
      statusTextArr: ['未开始', '进行中', '已结束']
    }
  },
  filters: {
    filterNotRead(num) {
      return num > 99 ? '99+' : num
    }
  },
  created() {
    this.getCoachInfo()
  },
  activated() {
    if (this.cid) {
      this.getCampList()
    }
  },
  methods: {
    bindClickSearch() {
      this.onSearch(this.searchText)
    },
    onSearch(value) {
      this.selectCampList = this.campList.filter((item) => {
        return item.camp_coach.includes(value) || item.title.includes(value)
      })
    },
    onRefresh() {},
    onLoad() {},
    //获取自己的信息
    getCoachInfo() {
      this.$http
        .getApp('member/AppCampCoach/checkUserIsCoach', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.cid = res.data.is_coach
            localStorage.setItem('coachId', res.data.is_coach)
            this.getCampList()
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {})
        .finally(() => {})
    },
    getCampList(refresh) {
      if (!this.cid) {
        this.loading = false
        this.finished = true
        return
      }
      let params = {
        cid: localStorage.getItem('coachId') || 0,
        refresh: refresh ? 1 : ''
      }
      this.$http
        .getApp('member/AppCampCoach/coachJoin', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data = this.filterCampList(res.data)
            this.campList = res.data
            this.onSearch(this.searchText)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.refreshing = false
          this.finished = true
        })
    },
    filterCampList(data) {
      data = data.map((item) => {
        let obj = this.statusArr.find((item1) => {
          return item1.status == item.is_end
        })
        if (item.is_end == 0) {
          item.statusText = '进行' + item.underway_day + '天'
        } else {
          item.statusText = obj.text
        }
        item.statusBg = obj.statusBg
        return item
      })
      return data
    },
    //跳转到
    jumpDynamicPage(item) {
      this.$router.push({
        path: '/nutritionist-tool/diet-list',
        query: {
          title: item.alias + ' ' + item.statusText,
          id: item.id,
          underway_day: item.underway_day
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.camp-page {
  background-color: #f9f9f9;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .search-btn {
    padding: 0px 10px;
    color: #2882e9;
  }

  .camp-content {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }

  .camp-scroll {
    height: 100%;
    overflow-y: auto;
  }
}

.camp-container {
  width: 100%;
}

.camp-list {
  padding: 16px;
  box-sizing: border-box;
}

.camp-item {
  position: relative;
  width: 100%;
  padding: 20px 14px 12px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 6px;
  margin-bottom: 10px;
}

.item-top {
  width: 100%;
  display: flex;
  align-items: center;
}

.camp-item .left {
  overflow: hidden;
  flex: 1;
  flex-shrink: 0;
}

.camp-item .top {
  width: 100%;
  margin-bottom: 6px;
}

.camp-item .name {
  font-size: 16px;
  color: #000;
  font-weight: 600;
}

.camp-item .not-read {
  height: 20px;
  line-height: 20px;
  background-color: #f04646;
  border-radius: 10px;
  color: #fff;
  padding: 0px 9px;
  font-size: 10px;
  margin-right: 4px;
}

.camp-item .iconfont {
  color: #666;
  font-size: 15px;
}

.camp-item .time {
  font-size: 10px;
  color: #000;
  white-space: nowrap;
}

.camp-item .coach-name {
  margin-left: 20px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  flex-shrink: 0;
}

.camp-item .bottom {
  display: flex;
  align-items: center;
}

.camp-item .status {
  position: absolute;
  left: 0;
  top: 0;
  height: 20px;
  line-height: 20px;
  padding: 0px 4px;
  font-size: 10px;
  color: #fff;
  border-radius: 6px 0px 6px 0px;
}

.not-more {
  margin: 30px 0px;
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
}

.observe-btn {
  position: relative;
  width: 100%;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 6px;
  background-color: #f1f1f1;
  border-radius: 4px;
  margin: 0 auto;
  color: rgb(0, 0, 0);
  font-size: 12px;
  font-family: PingFangSC-Regular;
  margin-top: 5px;
}

.observe-btn .iconfont {
  position: absolute;
  right: 7px;
  top: 50%;
  transform: translate(-50%, -50%);
  color: rgba(0, 0, 0, 0.5);
}
</style>
